"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const changeOverTime_1 = require("./changeOverTime");
class RevenueModel {
    get lastDAU() {
        return this.dau;
    }
    get balance() {
        return this.totalRevenue;
    }
    constructor(strategy) {
        this.config = strategy.config;
        this.strategy = strategy;
        this.changesOverTime = {};
        //TODO: may want to expose the piece-wise decay values
        //fill in decay lookup for D1 - Dsize
        this.decay = _(Array(this.config.days))
            .fill(.91, 0, 7)
            .fill(.97, 7, 30)
            .fill(.99, 30, this.config.days)
            .value();
        this.stepDay = 0;
        this.retention = Array(this.decay.length);
        this.dau = 0;
        this.cohorts = Array(this.retention.length);
        this.totalRevenue = 0;
    }
    step() {
        this.changeOverTimeStep(this.stepDay);
        // calculate retention for current stepDay
        for (let i = 0; i <= this.stepDay; ++i) {
            let ret = 0;
            if (!this.retention[i]) {
                ret = this.config.d1;
                this.retention[i] = Array(this.config.days);
            }
            else {
                let previous = this.retention[i][this.stepDay - 1 - i];
                let current = previous * this.decay[this.stepDay - i];
                ret = current;
            }
            this.retention[i][this.stepDay - i] = ret;
        }
        // calcualte DAU for the current step day
        let paidUsers = this.strategy.generatePaidUsers(this.stepDay);
        let organicUsers = this.strategy.generateOrganics(this.stepDay, paidUsers);
        // today's cohort
        this.cohorts[this.stepDay] = paidUsers + organicUsers;
        if (this.stepDay == 0) {
            this.dau = this.cohorts[this.stepDay];
        }
        else {
            this.dau = this.cohorts[this.stepDay];
            // dau is all previous cohorts transformed by retention + today's cohort
            for (let i = 0; i < this.stepDay; ++i) {
                //calculate previous cohorts transformed by retention
                this.dau += Math.round(this.cohorts[i] * this.retention[i][this.stepDay - 1 - i]);
            }
        }
        // calculate revenue/loss for the day
        let netPercent = 1 - this.config.platformFee;
        let rev = this.dau * this.config.arpdau;
        // rev after platform fee
        let netRev = rev * netPercent;
        // cost of acquiring new users
        let dnuCost = paidUsers * this.config.cpi;
        this.totalRevenue += netRev - dnuCost;
        ++this.stepDay;
        return this.stepDay;
    }
    changeOverTimeStep(day) {
        for (let key in this.changesOverTime) {
            let change = this.changesOverTime[key];
            switch (key) {
                case 'cpi':
                    this.config.cpi = change.calculate(day);
                    break;
                case 'spend':
                    this.config.dailySpend = change.calculate(day);
                    break;
                case 'kfactor':
                    this.config.kfactor = change.calculate(day);
                    break;
                case 'd1':
                    this.config.d1 = change.calculate(day);
                    console.log('D1: ' + this.config.d1);
                    break;
                case 'arpdau':
                    this.config.arpdau = change.calculate(day);
                    break;
            }
            change.notify();
        }
    }
    addChangeOverTime(kpi, value, days, onStep) {
        let change;
        let targetDay = this.stepDay + days;
        switch (kpi) {
            case 'cpi':
                change = new changeOverTime_1.ChangeOverTime(this.config.cpi, value, this.stepDay, targetDay, onStep);
                break;
            case 'spend':
                change = new changeOverTime_1.ChangeOverTime(this.config.dailySpend, value, this.stepDay, targetDay, onStep);
                break;
            case 'kfactor':
                change = new changeOverTime_1.ChangeOverTime(this.config.kfactor, value, this.stepDay, targetDay, onStep);
                break;
            case 'd1':
                change = new changeOverTime_1.ChangeOverTime(this.config.d1, value, this.stepDay, targetDay, onStep);
                break;
            case 'arpdau':
                change = new changeOverTime_1.ChangeOverTime(this.config.arpdau, value, this.stepDay, targetDay, onStep);
                break;
            default:
                return;
        }
        this.changesOverTime[kpi] = change;
    }
    getDecay(i) {
        if (i >= this.decay.length - 1) {
            return this.decay[this.decay.length - 1];
        }
        return this.decay[i];
    }
    /**
     * generates a retenture curve given a starting D1 retention
     */
    calculateRetention() {
        let ret = Array(this.decay.length);
        for (let i = 0; i < ret.length; ++i) {
            if (i == 0) {
                ret[i] = this.config.d1;
                continue;
            }
            let previous = ret[i - 1];
            let current = previous * this.decay[i];
            ret[i] = current;
        }
        return ret;
    }
    /**
     * returns the cohort sizes as it progresses through the retention curve
     * @param size the starting size of the cohort
     * @param retentionCurve the retention curve to use
     */
    calculateCohort(startSize, retentionCurve) {
        let cohort = Array(retentionCurve.length);
        cohort[0] = startSize;
        for (let i = 1; i < cohort.length; ++i) {
            cohort[i] = Math.round(startSize * retentionCurve[i - 1]);
        }
        return cohort;
    }
    /**
     * calculates the DAU based on new cohorts each day of a certain size
     * @param days the total number of days to model out
     * @param strategy the strategy we are using for paid and organics
     * @param retentionCurve the retention curve to use
     */
    calculateDAU(days, strategy, retentionCurve) {
        let size = days + retentionCurve.length;
        let cohort = _.fill(Array(size), 0, 0, size);
        for (let i = 0; i < days; ++i) {
            let pu = strategy.generatePaidUsers(i);
            let ou = strategy.generateOrganics(i, pu);
            let c = this.calculateCohort(pu + ou, retentionCurve);
            for (let j = 0; j < c.length; ++j) {
                cohort[j + i] += c[j];
            }
        }
        return cohort;
    }
    /**
     * calculates the revenue per day based on the DAU per day and costs
     * defined in ModelConfig (CPI, Platform fees, etc)
     * @param dau the number of DAU over time
     * @param strategy the strategy we are using for paid/organics
     */
    calculateRevenues(dau, strategy) {
        let revenues = _.fill(Array(dau.length), 0, 0, dau.length);
        let netPercent = 1 - this.config.platformFee;
        for (let i = 0; i < revenues.length; ++i) {
            let rev = dau[i] * this.config.arpdau;
            let netRev = rev * netPercent;
            let paidDNU = strategy.generatePaidUsers(i);
            //calculate cost for DNU
            let dnuCost = paidDNU * this.config.cpi;
            revenues[i] = netRev - dnuCost;
        }
        return revenues;
    }
}
exports.RevenueModel = RevenueModel;



// WEBPACK FOOTER //
// ./src/revenueModel.js